module.exports = __webpack_public_path__ + "img/partner8.47ea4436.png";